import React from 'react';
import PropTypes from 'prop-types';
import Contratacoes from '../../Contratacoes/Contratacoes';
import { useLocation } from 'react-router-dom';
import Timestamp from '../../Timestamp/Timestamp';
import { mergeQuery } from '../../../helpers/querystring';

const ContratacoesTemplate = (data) => {
  const { items, query } = data;
  const location = useLocation();
  const pathname = location.pathname;
  const newQuery = mergeQuery(location, query);
  return (
    <>
      <div className="items contratacao-template">
        <Timestamp />
        <Contratacoes
          contratacoes={items}
          params={newQuery}
          url={pathname}
          allowExport={true}
        />
      </div>
    </>
  );
};

ContratacoesTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default ContratacoesTemplate;
